import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {documentsColumns} from './columns/_columns'
import {News} from '../core/_models'
import {DocumentsListLoading} from '../components/loading/DocumentsListLoading'
import {DocumentsListPagination} from '../components/pagination/DocumentsListPagination'
import {KTCardBody} from '../../../../../../_metronic/helpers'

type PropTypes = {
  /** An array of columns that you don't want shown in the user list */
  hiddenColumns?: string[]
}

const DocumentsTable = ({hiddenColumns = []}: PropTypes) => {
  const documents = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => documents, [documents])
  const columns = useMemo(() => documentsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers
                .filter((column: ColumnInstance<News>) => !hiddenColumns.includes(column.id))
                .map((column: ColumnInstance<News>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0
              ? rows.map((row: Row<News>, i) => {
                  prepareRow(row)
                  return (
                    <CustomRow row={row} key={`row-${i}-${row.id}`} hiddenColumns={hiddenColumns} />
                  )
                })
              : !isLoading && (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        Nenhum registro correspondente encontrado
                      </div>
                    </td>
                  </tr>
                )}
          </tbody>
        </table>
      </div>
      <DocumentsListPagination />
      {isLoading && <DocumentsListLoading />}
    </KTCardBody>
  )
}

export {DocumentsTable}
